/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const cancelReasonEnumSchema = z
	.enum(["ClientNotAppeared", "ClientRefused", "Other"])
	.describe("* `ClientNotAppeared` - Гость не пришёл\n* `ClientRefused` - Гость отказался\n* `Other` - Другое");
